import Controller from './application_controller'

/**
 * Adds some extra functionality to turbo-frame elements.
 *
 * data-default-src:
 *   The default URL to set as the `src` of the frame.
 *   When set, the `src` will be cached and restored on subsequent
 *   initial loads of this frame.
 *   This allows using the the frame URL to cache state that will be
 *   restored if the user navigates back to the page later.
 */
export default class TurboFrameController extends Controller {
  static history = new Map()

  connect() {
    if (this.defaultSrc) {
      this.addEventListener('turbo:frame-load', event => {
        TurboFrameController.history.set(this.element.id, this.element.src)
      })

      this.element.src ??= this.lastSrc || this.defaultSrc
    }
  }

  get complete() {
    return this.element.hasAttribute('complete')
  }

  get lastSrc() {
    return TurboFrameController.history.get(this.element.id)
  }

  get defaultSrc() {
    return this.element.dataset.defaultSrc
  }

  reload() {
    if (this.complete) {
      this.element.reload()
    }
  }
}